import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import flatpickr from "flatpickr";
import "flatpickr/dist/themes/material_blue.css"; // Or any other theme
import FlatpickrDateInput from './FlatPickerDate';




const NewsModal = ({ isOpen, setIsOpen, editData, fetchPlans }) => {
    const [data, setData] = useState({
        date: "",
        heading: "",
        description: "",
        file: ""
    });

   useEffect(() => {
    if (editData) {
        let formattedDate = "";
        if (editData.date) {
            const d = new Date(editData.date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            formattedDate = `${day}/${month}/${year}`;
        }

        setData({
            ...editData,
            date: formattedDate
        });
    } else {
        setData({
            date: "",
            heading: "",
            description: "",
            file: ""
        });
    }
}, [editData]);



    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (selected, { name }) => {
        setData(prev => ({ ...prev, [name]: selected ? selected.value : "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        // formData.append("date", data.date || new Date().toISOString().split("T")[0]);
        let formattedDate = new Date().toISOString().split("T")[0]; // fallback

        if (data.date && data.date.includes("/")) {
            const [day, month, year] = data.date.split("/");
            formattedDate = `${year}-${month}-${day}`;
        }

        formData.append("date", formattedDate);

        formData.append("heading", data.heading);
        formData.append("description", data.description);

        if (data.file instanceof File) {
            formData.append("file", data.file);
        }

        const url = editData
            ? `https://releasesworld.100billionoms.com/news/${editData.id}`
            : "https://releasesworld.100billionoms.com/news";
        const method = editData ? "PUT" : "POST";

        try {
            const response = await fetch(url, {
                method,
                body: formData
            });

            if (response.ok) {
                toast.success(editData ? "News updated" : "News added");
                fetchPlans();
                setIsOpen(false);
            } else {
                const err = await response.json();
                toast.error(err.message || "Server error");
            }
        } catch (err) {
            console.error(err);
            toast.error("Request failed");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="oms-modal-title">{editData ? "Edit News" : "Add News"}</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-flex">
                        <div className="oms-form-group">
                            <label className="oms-form-label">Date</label>
                            <FlatpickrDateInput
                                value={data.date}
                                onChange={(dateStr) => {
                                    setData(prev => ({ ...prev, date: dateStr }));
                                }}
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Heading</label>
                            <input
                                type="text"
                                name="heading"
                                value={data.heading}
                                onChange={handleChange}
                                placeholder="Enter heading"
                                required
                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Description</label>
                            <textarea
                                name="description"
                                value={data.description}
                                onChange={handleChange}
                                placeholder="Enter description"

                            />
                        </div>

                        <div className="oms-form-group">
                            <label className="oms-form-label">Upload File (PDF/Image)</label>
                            <input
                                type="file"
                                accept=".pdf,.png,.jpg,.jpeg"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];
                                        if (!allowedTypes.includes(file.type)) {
                                            toast.error("Only PDF or image files are allowed.");
                                            return;
                                        }
                                        setData(prev => ({ ...prev, file }));
                                    }
                                }}
                            />
                            {editData?.file && !(data.file instanceof File) && (
                                <div style={{ marginTop: '8px' }}>
                                    <label></label>
                                    {
                                        /\.(jpg|jpeg|png|webp)$/i.test(editData.file) ? (
                                            <img
                                                src={`https://releasesworld.100billionoms.com/uploads/news/${editData.file}`}
                                                alt="Uploaded"
                                                style={{ maxWidth: '100px', marginTop: '5px' }}
                                            />
                                        ) : (
                                            <a
                                                href={`https://releasesworld.100billionoms.com/uploads/news/${editData.file}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View PDF
                                            </a>
                                        )
                                    }
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>Cancel</button>
                        <button type="submit">{editData ? "Update" : "Submit"}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewsModal;
